import {Component} from '@angular/core';
import {ContactUsService} from '../contact-us.service';
import {Branch} from '../../@models/branch.model';
import {DomSanitizer} from '@angular/platform-browser';
import {BranchDBService} from '../../@db/branch-db.service';

@Component({
  selector: 'bb-branch-info',
  templateUrl: './branch-info.component.html',
  styleUrls: ['./branch-info.component.scss'],
})
export class BranchInfoComponent {
  manilaURL = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1365.2075666778221!2d120.98134123527514!3d14.576832921054454!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3397ca2f30971857%3A0x2cdefd61f8eed89c!2sBalikbayad+-+OFW+and+Seaman+Loans+Made+Simple!5e0!3m2!1sen!2sph!4v1529812981907';
  mapUrl = this.contactUs.activeBranch
    .map((branch: Branch.Model) => {
      if (branch) {
        if (branch.google_map_url) {
          return branch.google_map_url;
        }
      }
      return this.manilaURL;
    })
    .map(url => this.sanitizer.bypassSecurityTrustResourceUrl(url))
    .shareReplay(1);

  branch = this.contactUs.activeBranch;
  branches = this.branchDb.list
    .filter(b => b.is_lead_choice)
    .toArray()
    .map(
      value => value.sort(function (a, b) {
        return a.sequence - b.sequence;
      }));
  branchControl = this.contactUs.form.get('branch');

  constructor(public contactUs: ContactUsService,
              private branchDb: BranchDBService,
              private sanitizer: DomSanitizer) {
  }
}
